<template>
  <div class="scrollable indexDIV">
    <v-header></v-header>
    <div class="indexdiv">
      <div class="breadNav">
        <div class="nav">
          <p>健康管理 > 家属体检 > 填写预约信息</p>
        </div>
      </div>
      <div class="msg">
        <div class="top" v-if="staffInfo.combo_total_count != 0">
          <p class="p1">
            <i></i>
            <span>尊敬的客户，您好！</span>
          </p>
          <p class="p2">
            您已通过公司弹性福利平台兑换了
            <span>{{ staffInfo.combo_total_count }}</span>
            次家属体检服务，目前剩余
            <span>{{ staffInfo.combo_balance_count }}</span> 次。
          </p>
        </div>
        <div class="bottom">
          <div class="item">
            <div class="tit">
              <p class="p1">
                <i></i>
                <span>全面关爱套餐</span>
              </p>
              <p class="p2">
                {{
                  free_count1 === 0 || free_count1 == ""
                    ? "￥660.00元"
                    : "可使用" + free_count1 + "次"
                }}
              </p>
            </div>

            <div class="content">
             全面的基础检查：包含内、外科，血、尿常规，肝、肾、甲状腺及其他身体代谢功能检查，广谱性肿瘤筛查，全面超声检查，胃肠道疾病筛查,心脑血管筛查等
            </div>
            <div class="subscribe" @click="subscribe('abb_f_entire_care')">
              <p>立即预约</p>
            </div>
          </div>
          <div class="item">
            <div class="tit">
              <p class="p1">
                <i></i>
                <span>深度珍爱套餐</span>
              </p>
              <p class="p2">
                {{
                  free_count === 0 || free_count == ""
                    ? "￥830.00元"
                    : "可使用" + free_count + "次"
                }}
              </p>
            </div>
              <div class="content">
              在全面关爱套餐的基础上，特别增加更多心脑血管筛查项目及其他检查项目，如血流变、心脏功能筛查等。
            </div>
            <div class="subscribe" @click="subscribe('abb_f_depth_care')">
              <p>立即预约</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import header from "../../common/header.vue";
import footer from "../../common/footer.vue";
export default {
  name: "indexDIV",
  data() {
    return {
      fullscreenLoading: false,
      cardData: [],
      rest_amount: "",
      total_amount: "",
      staffInfo: "",
      free_count: "",
      group_name: "",
      free_count1: "",
      group_name1: ""
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer
  },
  created() {
    this.staffInfo = JSON.parse(sessionStorage.getItem("staff_info"));
    this.staffInfo.combo.forEach(element => {
      if (element.group_name == "abb_f_depth_care") {
        this.free_count = element.free_count;
        this.group_name = element.group_name;
      }
      if (element.group_name == "abb_f_entire_care") {
        this.free_count1 = element.free_count;
        this.group_name1 = element.group_name;
      }
    });
  },
  mounted() {
    // this.cardList();
    // this.exchange_amount();
  },
  methods: {
    //   体检卡列表
    cardList() {
      let _this = this;
      _this.fullscreenLoading = false;
      axios
        .get(BASE_URL + "/exam/abb/card/", {
          params: {
            relative_type: 1
          }
        })
        .then(res => {
          _this.cardData = res.data.data;
          _this.fullscreenLoading = false;
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    exchange_amount() {
      let _this = this;
      _this.fullscreenLoading = false;
      axios
        .get(BASE_URL + "/exam/abb/card/exchange_amount/")
        .then(res => {
          _this.total_amount = res.data.data.total_amount;
          _this.rest_amount = res.data.data.rest_amount;
          _this.fullscreenLoading = false;
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    subscribe(item) {
      let _this = this;
      _this.$router.push({
        path: "/writeSubscribe",
        query: {
          type: _this.$route.query.type,
          batch: _this.$route.query.batch,
          group_name: item
        }
      });
    }
  },
  computed: {
    ...mapGetters(["resturantName", "resturantId", "qhText"])
  }
};
</script>

<style scoped>
.bottom {
  width: 1180px;
  margin: 0 auto;
  margin-top: 30px;
}
.bottom .item{
  float: left;
}
.bottom .item:nth-child(1){
  margin-right: 20px;
}
.bottom .item .subscribe {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  border-top: 1px solid #ccc;
}

.bottom .item .subscribe p {
  width: 180px;
  height: 46px;
  background: #ff000f;
  display: flex;
  justify-content: center;
  border-radius: 23px;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  line-height: 20px;
  cursor: pointer;
}

.bottom .item .content {
  padding: 0 41px ;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  display: flex; justify-content: center;align-items: center;
  height: 155px;
}



.bottom .item .tit {
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 14px 30px;
  display: flex;
  justify-content: space-between;
}

.bottom .item .tit .p1 {
  display: flex;
}

.bottom .item .tit .p1 i {
  display: block;
  width: 4px;
  height: 18px;
  background: #ff000f;
}

.bottom .item .tit .p1 span {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
  display: block;
  margin-left: 7px;
}

.bottom .item .tit .p2 {
  font-size: 18px;
  font-weight: 600;
  color: #ff000f;
  line-height: 18px;
}

.bottom .item {
  width: 48.5%;
  border: 1px solid #ccc;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.top {
  width: 1180px;
  margin: 0 auto;
  padding: 30px;
  border: 1px solid #ccc;
  margin-top: 30px;
}

.top .p2 {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
  margin-top: 18px;
}

.top .p2 span {
  color: #ff000f;
}

.top .p1 {
  display: flex;
}

.top .p1 i {
  width: 4px;
  display: block;
  height: 18px;
  background: #ff000f;
}

.top .p1 span {
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
  margin-left: 7px;
}

.msg {
  width: 1180px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.breadNav {
  width: 100%;
  height: 80px;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  align-items: center;
}

.breadNav .nav {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.breadNav .nav p:nth-child(1) {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 20px;
}

.breadNav .nav p:nth-child(2) {
  font-size: 24px;
  font-weight: 600;
  color: #ff000f;
  line-height: 24px;
}
.content .tiTle{
  margin-top: 20px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 24px;
}
.msg1{
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #333333;
  line-height: 24px;
}
.msg1 >span{
  color: #ff000f;
}
</style>



// WEBPACK FOOTER //
// src/components/phyExServices/selfPhyExService/familyMembers.vue